import { StatusVerifyController } from './verify.controller';
import template from './verify.html';

export const statusVerifyComponent = {
  name: 'statusVerifyComponent',
  restrict: 'E',
  template,
  controller: StatusVerifyController,
  controllerAs: 'vm',
  bindings: {},
};



// WEBPACK FOOTER //
// ./src/app/components/status/verify/verify.component.js